
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { SurveyRoutes } from "./SurveyRoutes";
import { SurveyStore } from "./SurveyStore";
import { Survey } from "./Survey";
import { SurveySuccess } from "./SurveySuccess";
import { SurveySigning } from "./SurveySigning";
import { NewPhone } from "components/common/NewPhone";
import { NewAddress } from "components/common/NewAddress";
import * as moment from "moment";
import ErrorScreen from "components/common/ErrorScreen";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class SurveyContainer extends React.Component<IProps, {}> {
    store: SurveyStore;

    constructor(props: any) {
        super(props);
        this.store = new SurveyStore();
    }

    async componentDidMount() {
        try {
            // Email from Mladen 2025-01-09: Remove title from survey, but keep document title and web header.
            // Need space " " to pass 'if (title)' check in GeorgeWebHeader.tsx
            georgeWebHeaderStore.configure({
                title: " ",
            });

            const expiryDate = externalInterfaceStore.expiryDate ? moment(externalInterfaceStore.expiryDate).endOf("day") : undefined;

            if (expiryDate && moment() > expiryDate) {
                pushRoute(SurveyRoutes.ERROR_EXPIRED);
            } else {
                pushRoute(SurveyRoutes.ROOT);
            }

            if (auth.authorized) {
                await this.store.load();
            }
        } catch (error) {
            debug.log("### SurveyContainer.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.store.contactsStore} />;
    }

    withMessage(Component: any, message: string) {
        return () => <Component {...this.props} message={message} />;
    }

    render() {
        document.title = ui.__("survey.document.title");

        return (
            <div>
                <Route exact path={SurveyRoutes.ROOT} render={this.withStore(Survey)} />
                <Route exact path={SurveyRoutes.SIGNING} render={this.withStore(SurveySigning)} />
                <Route exact path={SurveyRoutes.SUCCESS} render={this.withStore(SurveySuccess)} />
                <Route path={SurveyRoutes.NEW_PHONE} component={this.withContactsStore(NewPhone)} />
                <Route path={SurveyRoutes.NEW_ADDRESS} component={this.withContactsStore(NewAddress)} />
                <Route
                    path={SurveyRoutes.ERROR_EXPIRED}
                    render={this.withMessage(ErrorScreen, ui.__("survey.errorExpired.message"))}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/survey/SurveyContainer.tsx